:host {
    display: block;
}

.loader {
    margin: 0 auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgb(26 36 40 / 0.2);
    border-right: 1.1em solid rgb(26 36 40 / 0.2);
    border-bottom: 1.1em solid rgb(26 36 40 / 0.2);
    border-left: 1.1em solid #1a2428;
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;
    display: inline-block;
    vertical-align: middle;
    transition: opacity 0.3s linear;
}

.loader, .loader::after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
}

@keyframes load8 {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

:host(.indeterminate) {
    width: 100%;
}

.indeterminate-loader {
    cursor: wait;
    display: flex;
    align-items: center;
    border-radius: 3px;
    overflow: hidden;
    width: 100%;
}

.indeterminate-loader > * {
    width: 100%;
}

.indeterminate-loader__loading-bar {
    position: relative;
    overflow: hidden;
    height: 5px;
    border-radius: 3px;
    background-color: rgb(255 255 255 / 0.5);
    width: 100%;
}

.indeterminate-loader__loading-bar::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    content: "";
    animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    border-radius: 3px;
    background-color: rgb(255 255 255 / 0.5);
    will-change: left, right;
}

.indeterminate-loader__loading-bar::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    content: "";
    animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
    animation-delay: 1.15s;
    border-radius: 3px;
    background-color: rgb(255 255 255 / 0.5);
    will-change: left, right;
}

@keyframes indeterminate {
    0% {
        right: 100%;
        left: -35%;
    }

    60% {
        right: -90%;
        left: 100%;
    }

    100% {
        right: -90%;
        left: 100%;
    }
}

@keyframes indeterminate-short {
    0% {
        right: 100%;
        left: -200%;
    }

    60% {
        right: -8%;
        left: 107%;
    }

    100% {
        right: -8%;
        left: 107%;
    }
}